import script from "./PrepaidFreight.vue?vue&type=script&setup=true&lang=js"
export * from "./PrepaidFreight.vue?vue&type=script&setup=true&lang=js"

import "./PrepaidFreight.vue?vue&type=style&index=0&id=ef4156a0&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/www/releases/20260911022515/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ef4156a0"]])

export default __exports__